import { inject, Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { LoggerService } from './logger.service';
import { CookiesService } from '../_core/state/dialogs/cookies/service/cookies.service';

@Injectable({
  providedIn: 'root',
})
export class HeapService {
  private heapAppId: string;

  private readonly cookiesService = inject(CookiesService);

  constructor(
    private logger: LoggerService,
    private configService: ConfigService
  ) {
  }

  /**
   * Inserts heap script in <head>, takes heap app id from the configuration received.
   * If in devMode dont insert.
   */

  public init() {
    if (this.configService.initError) {
      return;
    }

    if (this.configService.devMode) {
      this.logger.info('No heap for you (development environment)');
      return;
    }

    this.heapAppId = this.configService.get().heapAppId;

    if (!this.heapAppId || !this.cookiesService.hasConsentForCookie('heap')) {
      return this.logger.warn('No Heap for you');
    }

    const heapScript = document.createElement('script');
    heapScript.type = 'text/javascript';
    heapScript.innerHTML = `window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};
    heap.load("${this.heapAppId}");`;
    document.head.appendChild(heapScript);
  }
}
